import { openDeleteBasicPaymentMethodModal } from './DeleteBasicPaymentMethod';
import { openDeletePaidPlanPaymentMethodModal } from './DeletePaidPlanPaymentMethod';

export const openDeletePaymentMethodModal = (hasPaidPlan: boolean): Promise<void> =>
  hasPaidPlan ? openDeletePaidPlanPaymentMethodModal() : openDeleteBasicPaymentMethodModal();
